import ContentElement from './content-element.js';
import type * as bs from 'bootstrap';

const bootstrap = window.bootstrap;
const $ = window.jQuery;

const DEFAULT_ELEMENT_SELECTOR: string = '.th-fsc-modal-wrapper';

interface ModalConfig {
    id?: string;
    storageName?: string;
    modal?: boolean;
    trigger?: string;
    clickContextCssSelector?: string;
    delay?: number;
    autoCloseTimeout?: number;
    disableOnQueryParameter?: string;
    scrollPosition?: string;
    scrollContextCssSelector?: string;
    frequency?: number;
    position?: string;
    fixed?: boolean;
    optout?: boolean;
    placementContext?: string;
    animation?: string;
    settings?: bs.Modal.Options;
}

const defaultOptions: ModalConfig = {
    id: '',
    storageName: 'modal',
    modal: false,
    trigger: '',
    clickContextCssSelector: '',
    delay: 0,
    autoCloseTimeout: 0,
    disableOnQueryParameter: '',
    scrollPosition: '',
    scrollContextCssSelector: '',
    frequency: 0,
    position: '',
    fixed: false,
    optout: false,
    placementContext: '',
    animation: '',
    settings: {
        backdrop: false,
        keyboard: true,
        focus: true

    }
};

class Modal extends ContentElement {
    protected options: ModalConfig = defaultOptions;

    public override init() {
        this.options = this.assignConfig<ModalConfig>(defaultOptions, this.config);
    }

    public override process() {
        const temp: HTMLElement = document.createElement('div');
        temp.innerHTML = this.element.textContent ?? '';
        const modalEl: HTMLElement = temp.firstElementChild as HTMLElement;

        const options: ModalConfig = this.options;

        const storageName = options['storageName'];
        let isEnable = true;

        let optoutTime: number = 0;
        let freqState: number = 0;
        let queryParameterHash: string = '';
        let queryParameterState: number = 0;
        const animationDuration: number = 400;

        if(window.localStorage.getItem(storageName + '-optout')) {
            optoutTime = parseInt(window.localStorage.getItem(storageName + '-optout')!);
        }
        if(window.localStorage.getItem(storageName + '-freq')) {
            freqState = parseInt(window.localStorage.getItem(storageName + '-freq')!);
            if(freqState < new Date().getTime()) {
                freqState = 0;
                window.localStorage.removeItem(storageName + '-freq');
            }
        }
        if(window.localStorage.getItem(storageName + '-qp.hash')) {
            queryParameterHash = window.localStorage.getItem(storageName + '-qp') ?? '';
        }
        if(window.localStorage.getItem(storageName + '-qp.expire')) {
            queryParameterState = parseInt(window.localStorage.getItem(storageName + '-qp.expire')!);
            if(queryParameterState < new Date().getTime()) {
                window.localStorage.removeItem(storageName+'-qp');
                window.localStorage.removeItem(storageName+'-qp.expire');
                queryParameterHash = '';
                queryParameterState = 0;
            }
        }

        if(options.optout && optoutTime > 0) {
            isEnable = false;
        }

        if(isEnable && options.frequency && options.frequency > 0) {
            if(freqState < 1) {
                const now = new Date();
                const expires = now.getTime() + (options.frequency * 1000);
                window.localStorage.setItem(storageName+'-freq', expires.toString());
            } else {
                isEnable = false;
            }
        }

        if(options.disableOnQueryParameter && options.disableOnQueryParameter != '') {
            const parameterHash = window.btoa(options.disableOnQueryParameter);
            if(window.location.href.search(options.disableOnQueryParameter) > -1) {
                const expires = new Date().getTime() + (86400 * 182 * 1000);
                window.localStorage.setItem(storageName+'-qp', parameterHash);
                window.localStorage.setItem(storageName+'-qp.expire', expires.toString());
            }

            if(queryParameterState > 0 && queryParameterHash == parameterHash) {
                isEnable = false;
            }
        }

        if(isEnable) {
            // Move modal to body
            document.body.append(modalEl);

            let backdrop = false;
            let focusModal = false;
            if(options.modal) {
                backdrop = true;
            }
            if(options.trigger == 'click') {
                focusModal = true;
            }

            const settings = options.settings ?? {
                backdrop: true,
                keyboard: true,
                focus: false
            };

            settings.backdrop = backdrop;
            settings.focus = focusModal;

            const modal: bootstrap.Modal = bootstrap.Modal.getOrCreateInstance(modalEl, settings);
            const modalDialogEl: HTMLElement = modalEl.querySelector('.modal-dialog')!;

            if(options.fixed) {
                modalDialogEl.classList.add('position-fixed');
            }
            if(options.position != '') {
                modalDialogEl.classList.add('position-' + options.position);
            }

            const buttonCloseEl: HTMLElement|null = modalEl.querySelector<HTMLElement>('[data-action="close"]');
            let buttonOpenEl: HTMLElement|null = null;
            if(options.clickContextCssSelector && options.clickContextCssSelector != ''){
                buttonOpenEl = document.querySelector<HTMLElement>(options.clickContextCssSelector)
            }
            const buttonOptoutEl: HTMLElement|null = modalEl.querySelector('[data-action="ban"]');

            let scrollTimeOut: number;
            let displayCount: number = 0;
            const modalDialogStyleAttribute: string = modalDialogEl.getAttribute('style') ?? '';

            window.document.addEventListener('keyup', (ev: KeyboardEvent) => {
                if(ev.key && ev.key === 'Escape') {
                    modal.hide();
                }
            });

            modalEl.addEventListener('shown.bs.modal', () => {
                modalDialogEl.setAttribute('style', modalDialogStyleAttribute);
                if(!options.modal) {
                    modalEl.style.top = document.body.scrollTop+'px';
                    if(options.placementContext == 'mainContent') {
                        let hh = (document.querySelector('.th-page-header') as HTMLElement).offsetHeight;
                        hh = Math.ceil(hh/2);
                        modalDialogEl.style.marginTop = hh+'px';
                    }
                }

                displayCount++;
                const modalDialogMarginLeft: string = modalDialogEl.style.marginLeft;
                const modalDialogMarginTop: string = modalDialogEl.style.marginTop;

                modal.show();
                switch(options.animation) {
                    case 'slide':
                        $(modalDialogEl).slideDown(animationDuration);
                    break;
                    case 'fade':
                        $(modalDialogEl).fadeIn(animationDuration);
                    break;
                    case 'slideInLeft':
                        modalDialogEl.style.marginLeft = '-100%';
                        $(modalDialogEl).animate({
                            'margin-left': modalDialogMarginLeft
                        }, {
                            duration: animationDuration
                        });
                    break;
                    case 'slideInRight':
                        modalDialogEl.style.marginLeft = '100%';
                        $(modalDialogEl).animate({
                            'margin-left': modalDialogMarginLeft
                        }, {
                            duration: animationDuration
                        });
                    break;
                    case 'slideInTop':
                        modalDialogEl.style.marginTop = '-100%';
                        $(modalDialogEl).animate({
                            'margin-top': modalDialogMarginTop
                        }, {
                            duration: animationDuration
                        });
                    break;
                    case 'slideInBottom':
                        modalDialogEl.style.marginTop = '100%';
                        $(modalDialogEl).animate({
                            'margin-top': modalDialogMarginTop
                        }, {
                            duration: animationDuration
                        });
                    break;
                }
                if(options.autoCloseTimeout ?? 0 > 0) {
                    window.setTimeout(function() {
                        modal.hide();
                    }, options.autoCloseTimeout! * 1000);
                }
            });

            modalEl.addEventListener('show.bs.modal', () => {
                if(options.modal) {
                    document.querySelector('.th-page-wrapper')!.classList.add('filter-blur');
                }
            });
            modalEl.addEventListener('hide.bs.modal', () => {
                if(options.modal) {
                    document.querySelector('.th-page-wrapper')!.classList.remove('filter-blur');
                }
            });
            modalEl.addEventListener('toggle', () =>  {
                window.setTimeout(function() {
                    if(displayCount < 1) {
                        modal.show();
                    }
                }, options.delay ?? 0 * 1000);
            });
            modalEl.addEventListener('show', () => {
                modal.show();
            });
            modalEl.addEventListener('hide', () => {
                modal.hide();
            });
            if(buttonCloseEl) {
                buttonCloseEl.addEventListener('click', (e) => {
                    e.preventDefault();
                    modal.hide();
                });
            }

            if(buttonOptoutEl != null) {
                buttonOptoutEl.setAttribute('href', '#');
                buttonOptoutEl.addEventListener('click', (ev: MouseEvent) => {
                    ev.preventDefault();
                    modal.hide();
                    modal.dispose();
                    const now = new Date();
                    const expires = now.getTime() + (86400*182*1000);
                    window.localStorage.setItem(storageName + '-optout', expires.toString());
                });
            }

            modal.handleUpdate();
            window.addEventListener('resize', () => { modal.handleUpdate() });
            window.addEventListener('orientationchange', () => { modal.handleUpdate() });

            if(options.trigger != '') {
                switch(options.trigger) {
                    case 'click': {
                        if(buttonOpenEl) {
                            buttonOpenEl.addEventListener('click', (ev: MouseEvent) => {
                                ev.preventDefault();
                                modal.toggle();
                            });
                        }
                        break;
                    }
                    case 'load': {
                        window.setTimeout(function() {
                            if(displayCount < 1) {
                                modal.show();
                            }
                        }, options.delay ?? 0 * 1000);
                        break;
                    }
                    case 'scroll': {
                        let offsetToAdd: number = 0;
                        let scrollContextEl: HTMLElement|null = document.body;
                        if(options.scrollContextCssSelector && options.scrollContextCssSelector != '') {
                            scrollContextEl = document.querySelector(options.scrollContextCssSelector);
                            if(scrollContextEl) {
                                offsetToAdd = scrollContextEl.offsetTop;
                            }
                        }
                        let triggerScrollTopPosition = parseInt(options.scrollPosition ?? '');
                        if(options.scrollPosition && options.scrollPosition.search('%') > -1 && scrollContextEl) {
                            triggerScrollTopPosition = scrollContextEl.offsetHeight * triggerScrollTopPosition / 100;
                        }

                        triggerScrollTopPosition += offsetToAdd;

                        const handleScroll = () => {
                            window.clearTimeout(scrollTimeOut);
                            scrollTimeOut = window.setTimeout(function() {
                                if(window.scrollY >= triggerScrollTopPosition && displayCount < 1) {
                                    modal.toggle();
                                }
                            }, 100);
                        };

                        window.addEventListener('scroll', () => {
                            handleScroll();
                        });
                        handleScroll();
                        break;
                    }
                    case 'unload': {
                        window.addEventListener('unload', () => {
                            if(displayCount < 1) {
                                modal.show();
                            }
                        });
                        break;
                    }
                    case 'mouseout': {
                        document.body.addEventListener('mouseout', () => {
                            if(displayCount < 1) {
                                modal.show();
                            }
                        });
                        break;
                    }
                }
            }

        }

        this.element.remove();
    }

}

// Observe
Modal.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export type { ModalConfig };
export default Modal;
